(function() {
	'use strict';

	angular
		.module('app.setup')
		.service('customerSettingService', customerSettingService);

	customerSettingService.$inject = ['$http'];

	function customerSettingService($http) {
		var baseUrl = '/api/2/factndx/{0}/CustomerSetting/';

		return {
			getCustomerSettings: getCustomerSettings,
			saveCustomerSettings: saveCustomerSettings
		};

		function getCustomerSettings(settingNames, factoryId) {
			if (typeof(settingNames) === 'string') {
				settingNames = [settingNames];
			}
			var url = String.format(baseUrl, factoryId || globalConfig.factory.id) + '?settingNames=' + settingNames;
			return $http.get(url)
				.then(getCustomerSettingSuccess, getCustomerSettingError);

			function getCustomerSettingSuccess(response) {
				return response.data;
			}
			function getCustomerSettingError(error) {
				return error;
			}
		}
		
		// pass multiple settings as a dictionary
		function saveCustomerSettings(settings, factoryId) {
			var settingsList = [];
			for(var setting in settings) {
				if (settings.hasOwnProperty(setting)) {
					settingsList.push({
						name: setting,
						value: settings[setting]
					});
				}
			}
			return $http.put(String.format(baseUrl, factoryId || globalConfig.factory.id), settingsList)
				.then(saveCustomerSettingsSuccess, saveCustomerSettingsError);

			function saveCustomerSettingsSuccess(response) {
				return 'Settings saved successfully';
			}
			function saveCustomerSettingsError(error) {
				return 'Server error';
			}
		}
	}
})();
